import { render, staticRenderFns } from "./button-group-block.vue?vue&type=template&id=327c41b6&scoped=true"
import script from "./button-group-block.vue?vue&type=script&lang=js"
export * from "./button-group-block.vue?vue&type=script&lang=js"
import style0 from "./button-group-block.vue?vue&type=style&index=0&id=327c41b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c41b6",
  null
  
)

export default component.exports